export const getAccountId = () => {
  // 从当前URL路径中获取accountId
  const isInsideAccountScopedURLs = window.location.pathname.includes('/app/accounts');

  if (isInsideAccountScopedURLs) {
    return window.location.pathname.split('/')[3];
  }

  // 如果无法从URL获取accountId，则尝试从localStorage获取最后使用的accountId
  const lastUsedAccount = localStorage.getItem('cwt_last_used_account_id');
  
  if (lastUsedAccount) {
    return lastUsedAccount;
  }

  // 如果都获取不到，返回默认值1
  return '1';
}; 